module.exports = __webpack_public_path__ + "static/media/WelcomeStudent.24a5c85a.svg";